import { app } from '../../../app';

class RequestCenterService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }


    createRequest(requestDTO) {
        const url = `app/rest/accessrequests`;
        return this.$http.post(url, requestDTO).then(({data}) => data);
    }

    getRequests() {
        const url = `app/rest/accessrequests`;
        return this.$http.get(url).then(({data}) => data);
    }
    
    getApprovals() {
        const url = `app/rest/accessrequests/approvals`;
        return this.$http.get(url).then(({data}) => data);
    }

    approveRequestByApprovalManager(requestId) {
        const url = `app/rest/accessrequests/approvals/${requestId}?action=approve`;
        return this.$http.post(url).then(({data}) => data);
    }

    denyRequestByApprovalManager(requestId) {
        const url = `app/rest/accessrequests/approvals/${requestId}?action=deny`;
        return this.$http.post(url).then(({data}) => data);
    }

    getCompanies() {
        const url = `app/rest/accessrequests/companies`;
        return this.$http.get(url).then(({data}) => data);
    }

    getApplications(companyId) {
        const url = `app/rest/accessrequests/companies/${companyId}/applications`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAccounts(companyId) {
        const url = `app/rest/accessrequests/companies/${companyId}/accounts`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteRequest(requestId) {
        const url = `app/rest/accessrequests/${requestId}`;
        return this.$http.delete(url).then(({data}) => data);   
    }

    getRequestsForCompany(companyId) {
        const url = `app/rest/company/${companyId}/accessrequest`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteRequestForCompany(companyId, requestId) {
        const url = `app/rest/company/${companyId}/accessrequest/${requestId}`;
        return this.$http.delete(url).then(({data}) => data);         
    }

    approveRequest(companyId, requestId) {
        const url = `app/rest/company/${companyId}/accessrequest/${requestId}/approve`;
        return this.$http.post(url).then(({data}) => data);
    }

    denyRequest(companyId, requestId) {
        const url = `app/rest/company/${companyId}/accessrequest/${requestId}/deny`;
        return this.$http.post(url).then(({data}) => data);
    }
}

app.service('RequestCenterService', RequestCenterService);



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/request-center.service.js